
import React from 'react';
import {
  Form, Input, Button, DatePicker, Select,
} from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Box } from '../../shared/components';

require('moment/locale/es.js');

const { TextArea } = Input;
const { Option } = Select;
let tipoRepetirPrevio = null;
const dateFormat = 'DD/MM/YYYY HH:mm';

function EventForm(props) {
  const {
    form, loading, onSubmit, onCancel, datos, onChangeDiaSeleccion, stringDiaSeleccion,
    numberDiaSeleccion, stringMesSeleccion, stringSemanaSeleccion,
  } = props;
  const { getFieldDecorator } = form;
  const {
    id, title, desc, start, repetir,
  } = datos || '';
  tipoRepetirPrevio = repetir;
  const accion = (id) ? 'editar' : 'crear';
  let withSaveBtn = '52px';
  let labelSaveBtn = 'Crear';
  if (accion === 'editar') {
    withSaveBtn = '66px';
    labelSaveBtn = 'Guardar';
  }

  if (start && (start.getHours() === 0)) {
    start.setHours(9);
  }

  return (
    <Box verticalAlign="middle">

      <Form
        onSubmit={(e) => {
          e.preventDefault();
          form.validateFields((err, values) => {
            if (!err) {
              onSubmit(values);
              form.resetFields();
            }
          });
        }}
        className="event-form"
      >
        <Form.Item required={false} label="Id" style={{ display: 'none' }}>
          {getFieldDecorator('id', {
            initialValue: (id || null),
            rules: [
              { required: false, message: '' }],
          })(
            <Input readOnly />,
          )}
        </Form.Item>

        <Form.Item required={false} label="Título" colon={false}>
          {getFieldDecorator('titulo', {
            initialValue: (title || ''),
            rules: [
              { required: true, message: '' }],
          })(
            <Input
              readOnly={loading}
            />,
          )}
        </Form.Item>

        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Form.Item style={{ flex: 1, marginRight: '4px' }} required={false} label="Fecha y hora" colon={false}>
            {getFieldDecorator('fecha_hora', {
              initialValue: (start ? moment(start) : moment()),
              rules: [{ required: true, message: '' }],
            })(
              <DatePicker
                onChange={onChangeDiaSeleccion}
                showTime={{ format: 'HH:mm' }}
                readOnly={loading}
                format={dateFormat}

              />,
            )}
          </Form.Item>
          <Form.Item style={{ flex: 1, marginLeft: '4px', maxWidth: '238px' }} required={false} label="Repetir cada..." colon={false}>
            {getFieldDecorator('repetir', {
              initialValue: (repetir || 1),
              rules: [{ required: true, message: '' }],
            })(
              <Select dropdownMatchSelectWidth={false}>
                <Option value={1}>No repetir</Option>
                <Option value={2}>Diariamente</Option>
                <Option value={3}>
                  Semanalmente, los
                  {' '}
                  {stringDiaSeleccion}
                </Option>
                <Option value={4}>
                  Mensualmente, el
                  {' '}
                  {stringSemanaSeleccion}
                  {' '}
                  {stringDiaSeleccion}
                  {' '}
                  de mes
                </Option>
                <Option value={5}>
                  Anualmente, el
                  {' '}
                  {numberDiaSeleccion}
                  {' '}
                  de
                  {' '}
                  {stringMesSeleccion}
                </Option>
                <Option value={6}>De Lunes a Viernes</Option>
              </Select>,
            )}
          </Form.Item>
        </Box>
        <Form.Item required={false} label="Descripción" colon={false}>
          {getFieldDecorator('descripcion', {
            initialValue: (desc || ''),
            rules: [{ required: false, message: '' }],
          })(
            <TextArea
              rows={4}
              readOnly={loading}
            />,
          )}
        </Form.Item>

        <Form.Item>
          <Box style={{ textAlign: 'right' }}>
            <Button
              style={{ width: '72px', height: '24px', margin: '0px 4px 0px 0px' }}
              block
              loading={loading}
              type="secondary"
              htmlType="button"
              onClick={onCancel}
            >
              Cancelar
            </Button>
            <Button
              style={{ width: withSaveBtn, height: '24px', margin: '0px 0px 0px 4px' }}
              block
              loading={loading}
              type="primary"
              htmlType="submit"
              className="event-form-button"
            >
              {labelSaveBtn}
            </Button>
          </Box>
        </Form.Item>

      </Form>


    </Box>
  );
}
/* eslint react/forbid-prop-types: 0 */
EventForm.propTypes = {
  form: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

const EventFormComponent = Form.create({ name: 'event_login' })(EventForm);
export default EventFormComponent;
